<template>
  <BasePageFull :body-scroll="false">
    <template #title>
      <div class="flex space-x-3">
        <font-awesome-icon :icon="['fal', 'database']" size="2x" />
        <span class="text-2xl font-bold capitalize-first">
          {{ $t('navigation.urn_title') }}
        </span>
      </div>
    </template>
    <template #cta>
      <BaseButton
        color="primary"
        icon="long-arrow-left"
        :title="$t('button.back')"
        @click="$router.go(-1)"
      />
    </template>
    <template #body>
      <BaseContentTable
        v-if="metadata.columns || loading"
        :columns="metadata.columns ?? []"
        :loading="loading"
        :model-list="filteredUrnList"
        :search="true"
        redirect_to_field="work_id"
        :is-hoverable="true"
        :is-responsive="true"
        scrollable
        @row-click="redirectToModelPage"
        @refresh-click="withLoading(fetchUrnsIndex())"
        @delete-model="deleteModelById"
      >
        <template #toolbar>
          <span class="font-bold capitalize-first">{{ getTitleSwitch }}</span>
          <BaseSwitch
            :key="all_urns"
            v-model="all_urns"
            name="subject_to_confirmation"
          />
        </template>
      </BaseContentTable>
    </template>
  </BasePageFull>
</template>

<script>
import loadingMixin from '@u/mixins/loading.mixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'UrnIndex',
  mixins: [loadingMixin],
  data() {
    return {
      all_urns: false
    }
  },
  computed: {
    ...mapGetters({
      urnList: 'urn/getUrnIndex',
      metadata: 'urn/getUrnMetadata'
    }),
    filteredUrnList() {
      if (this.all_urns === true) {
        return this.urnList
      }
      return this.urnList.filter((urn) => !urn.awaiting_dead_line)
    },
    getTitleSwitch() {
      return this.$t(
        this.all_urns ? 'button.hide_plural' : 'button.show_plural',
        { var: this.$t('global.urn_returned') }
      )
    }
  },
  methods: {
    ...mapActions({ fetchUrnsIndex: 'urn/fetchUrnIndex' }),
    redirectToModelPage(id) {
      this.$router.push({ name: 'work_form_urn_route', params: { id: id } })
    },
    deleteModelById() {}
  },
  beforeMount() {
    this.withLoading(this.fetchUrnsIndex())
  }
}
</script>

<style scoped></style>
